/* LW 23.10.26: Lagerhinweis (#reload) nach Varianten-Wechsel aktualisieren.
   Ersetzt die alte jQuery-Version, die bei jedem Klick die komplette Produktseite neu geladen hat.
   Jetzt: nur die Produkt-Section (Section Rendering API), alte Anfragen werden abgebrochen. */
(function () {
  if (!/\/products\//.test(location.pathname)) return;

  var controller = null;
  var timer = null;

  function refresh() {
    var el = document.getElementById('reload');
    if (!el) return;

    var url = new URL(location.href);
    var section = el.closest('.shopify-section');
    if (section && section.id.indexOf('shopify-section-') === 0) {
      url.searchParams.set('section_id', section.id.replace('shopify-section-', ''));
    }

    if (controller) controller.abort();
    controller = 'AbortController' in window ? new AbortController() : null;

    fetch(url.toString(), controller ? { signal: controller.signal } : {})
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.getElementById('reload');
        var current = document.getElementById('reload');
        if (fresh && current) current.innerHTML = fresh.innerHTML;
      })
      .catch(function () {});
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(refresh, 150);
  }

  document.addEventListener('change', function (e) {
    if (e.target.closest && e.target.closest('.product, form[action*="/cart/add"]')) schedule();
  });
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('.product input, .product button, .product select, .product label')) schedule();
  });
})();
